import styled, { css } from 'styled-components';

/**
 * Tinted square that holds an icon (marketing `bg-primary/10 text-primary`).
 *
 *   <IconTile><Gift size={20} strokeWidth={1.75} /></IconTile>
 *   <IconTile $size="sm"><Gift size={16} strokeWidth={1.75} /></IconTile>
 */
const IconTile = styled.span`
  align-items: center;
  background-color: color-mix(in oklab, var(--primary) 10%, transparent);
  border-radius: var(--radius-xl);
  color: var(--primary);
  display: inline-flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  width: 40px;

  ${({ $size }) =>
    $size === 'sm' &&
    css`
      border-radius: var(--radius-lg);
      height: 32px;
      width: 32px;
    `};
`;

export default IconTile;
